<template>
  <div class="page-wrapper">
    <div class="page-header">
      <WidgetToolbar :back="true" title="Accounts" :icon="require('@/assets/icon/accounts-active.svg')"
        @onBack="$navigationGoBack('/accounts')">
        <div class="options">
          <widgetSearch class="search-account" placeholder="Type in to Search..." icon="right" v-model="search_input">
          </widgetSearch>

          <div class="h-spacer"></div>

          <widgetDropdown v-model="sort_input_filter" :right="true" :hover="false" :interactive="true">
            <button class="btn-dropdown">
              <span v-if="selected_filter == 'all'">All Notes</span>
              <span v-if="selected_filter == 'today'">Today</span>
              <span v-if="selected_filter == 'last_week'">Last week</span>
              <span v-if="selected_filter == 'last_month'">Last month</span>
              <span v-if="selected_filter == 'last_year'">Last year</span>
              <img class="icon" src="@/assets/icon/carret-bottom-gray.svg" />
            </button>
            <div slot="dropdown" class="dropdown-widget right">
              <a class="dropdown-item" href="#" v-for="(item, index) in view_filter" :key="index"
                @click="filterNotes(item.value)">
                {{ item.name }}</a>
            </div>
          </widgetDropdown>
          <div class="v-line-divider" style="height: 40px"></div>

          <widgetButton @click="addNewNote()" :loading="false" style="width: 120px" class="btn-primary">
            Add New +
          </widgetButton>
          <div class="v-line-divider" style="height: 20px"></div>
          <dropdown-menu class="table-menu">
            <ul>
              <li>
                <a @click.prevent="openUploadNotesModal()">Upload Notes</a>
              </li>
            </ul>
          </dropdown-menu>
        </div>
      </WidgetToolbar>
    </div>
    <div class="page-tab">
      <div class="page-path-widget">
        <img @click="$router.push({ path: '/accounts' })" src="@/assets/icon/accounts-active.svg" class="icon" />
        <label @click="$router.push({ path: '/accounts' })" class="path-name link">Accounts</label>
        <img src="@/assets/icon/outline-carret-green.svg" class="allow" />
        <label class="path-name"> {{ account.name }} </label>
      </div>

      <div class="page-tab-options row">
        <widgetButton :loading="false" @click="getAllNotes()" class="btn-transparent fit-content">
          <img src="@/assets/icon/reflesh-gray.svg" width="15" />
        </widgetButton>
      </div>
    </div>
    <div class="page-body">
      <accountSidebar switch_tab="notes" :account="account"></accountSidebar>
      <div class="instruct-wrapper" v-if="true">
        <div class="tab-options"></div>
        <div class="instruct-widget">
          <multipane class="custom-resizer" layout="vertical">
            <div class="instruct-list">
              <div class="instruct-body">
                <!-- <div
              class="notes-body-widget"
              :class="{ note_preview_showing: !show_add_notes }"
            >
              <div
                class="note-item"
                v-for="(item, index) in notes_data"
                :key="index"
                :class="{ [item.color]: true }"
                @click="selectNote(item)"
              >
                <p class="note-content" v-html="item.content"></p>
                <img
                  class="page-flip"
                  src="@/assets/admin-icon/page-flip.svg"
                />
              </div>
            </div> -->

                <table class="table-data">
                  <thead class="table-header">
                    <tr>
                      <th class="stick-title" width="250">
                        <div class="force-start">
                          <!-- <input @change="checkAllActivities" type="checkbox" /> -->
                          Notes
                        </div>
                      </th>
                      <th class="stick-title" width="200">Created Date</th>
                      <th class="stick-title" width="150">Created by</th>
                      <th class="stick-title" width="20"></th>
                    </tr>
                  </thead>
                  <tbody class="table-body">
                    <template>
                      <tr class="row-data" v-for="(item, index) in notes_data" :key="index">
                        <td @click="selectNote(item)">
                          <div class="activity-content">
                            <!-- <input
                          @change="checkActivity"
                          class="checkbox"
                          type="checkbox"
                        /> -->
                            <img src="@/assets/admin-icon/note.svg" />
                            <div class="activity-label">
                              {{ htmlToText(item.content) }}
                            </div>
                          </div>
                        </td>
                        <td @click="selectNote(item)" class="email">
                          {{ item.created_at | formatDateTime }}
                        </td>

                        <td @click="selectNote(item)">
                          <widgetProfile v-if="item.owner" :title="item.owner.name" :subtitle="''"
                            :file_name="item.owner.profile_image" :path="$fullUrl('images/profiles/')"></widgetProfile>
                        </td>

                        <td>
                          <dropdown-menu class="table-menu">
                            <ul>
                              <li>
                                <app-dialog title="Delete Note" ask="Are you sure you want to delete this note?"
                                  yesText="Delete" noText="Cancel" @onComfirm="deleteNote(item)">
                                  <a>Delete Note</a>
                                </app-dialog>
                              </li>
                            </ul>
                          </dropdown-menu>
                        </td>
                      </tr>
                    </template>
                  </tbody>
                </table>

                <!-- Loading preview -->
                <div class="loading-widget" v-if="isLoading">
                  <loading :height="40" :width="40" :active="true" color="#000" :is-full-page="false" />
                </div>
              </div>
            </div>
            <multipane-resizer v-if="show_add_notes"></multipane-resizer>
            <div class="instruct-details" v-if="show_add_notes" :style="{ flexGrow: 1 }">
              <div class="note-form-widget">
                <div class="note-form">
                  <html-editor placeholder="Enter your notes" v-model="form.content" class="notes-editor-widget"
                    id="edit-descr" />
                  <div class="note-colors-widget" v-if="false">
                    <div v-for="(color, index) in note_colors" :key="index" class="color-item"
                      :class="{ [color]: true, active: form.color == [color] }" @click="selectNoteColor(color)"></div>
                  </div>
                </div>

                <div class="note-options row">
                  <widgetButton :loading="submit_note_loading" @click="submitNote()" class="btn-secondary">
                    Save
                  </widgetButton>
                  <div class="h-spacer"></div>

                  <widgetButton @click="cancelAddNotes()" class="btn-transparent-secondary">
                    Cancel
                  </widgetButton>
                </div>
              </div>
            </div>
          </multipane>
        </div>
      </div>
      <div class="instruct-wrapper" v-else>
        <div class="student-not-found-widget">
          <widgetNotFoundWidget title="No Notes Found"
            content="Notes are not available, click Add New button for new note" btntext="Add New"
            @click="addNewNote()">
            <img class="widget-img" src="@/assets/admin-icon/student-search-icon.svg" />
          </widgetNotFoundWidget>
        </div>
      </div>
    </div>

    <uploadNotesModal v-if="showuploadNotesModal" @success="onUploadSucess" @close="showuploadNotesModal = false">
    </uploadNotesModal>

  </div>
</template>

<script>
import { eventBus } from "@/main";
import accountSidebar from "@/views/Accounts/components/account_sidebar.vue";
import uploadNotesModal from "@/views/Accounts/AccountsView/components/upload_notes_modal.vue"
export default {
  name: "",
  components: {
    accountSidebar,
    uploadNotesModal
  },
  data: () => {
    return {
      showuploadNotesModal: false,
      sort_input_filter: false,
      account: {},
      search_input: "",
      selected_filter: "all",
      view_filter: [
        {
          value: "all",
          name: "All Notes",
        },
        {
          value: "today",
          name: "Today",
        },
        {
          value: "last_week",
          name: "Last week",
        },
        {
          value: "last_month",
          name: "Last month",
        },
        {
          value: "last_year",
          name: "Last year",
        },
      ],
      note_colors: ["light_yellow", "light_red", "light_green", "light_grey"],
      notes_data: [],
      isLoading: false,
      show_selected_activities_options: false,
      form: {
        id: null,
        account_id: null,
        content: "",
        color: "light_yellow",
        owner: null,
      },
      submit_note_loading: false,
      show_add_notes: false,
      form_filter: {
        account_id: null,
        filter: "all",
        query: "",
      },
    };
  },
  mounted() {
    let vm = this;
    vm.getAllNotes();
    vm.getStartData();
  },
  computed: {},
  watch: {
    search_input(query) {
      let vm = this;
      vm.searchNote(query);
    },
    selected_filter(type) {
      let vm = this;
      if (type == "all") {
        vm.getAllNotes();
      } else {
        vm.filterNote(type);
      }
    },
  },
  methods: {
    onUploadSucess() {
      let vm = this;
      vm.showuploadNotesModal = false;
      vm.getAllNotes();
    },
    openUploadNotesModal() {
      let vm = this;
      vm.showuploadNotesModal = true;
    },
    getStartData() {
      let vm = this;
      vm.$store.dispatch("LOADER_START");
      vm.$store
        .dispatch("ACCOUNT_SINGLE_GET_ALL_DATA", {
          account_id: vm.$route.params.id,
        })
        .then((responce) => {
          vm.$store.dispatch("LOADER_CLOSE");
          vm.account = responce.data;
        })
        .catch((error) => {
          vm.$store.dispatch("LOADER_CLOSE");
        });
    },
    selectNote(item) {
      let vm = this;
      vm.form.id = item.id;
      vm.form.content = item.content;
      vm.form.color = item.color;
      vm.form.account_id = item.account_id;
      vm.show_add_notes = true;
    },
    submitNote() {
      let vm = this;
      vm.submit_note_loading = true;
      vm.form.owner = {
        name: vm.$getLoggedUser().manager_name,
        profile_image: vm.$getLoggedUser().manager_picture,
      };
      if (!vm.form.id) {
        vm.$store
          .dispatch("NOTES_ADD_NEW", vm.form)
          .then((responce) => {
            vm.submit_note_loading = false;
            vm.getAllNotes();
            vm.$notify({
              group: "status",
              title: "Success",
              text: "Note is now added",
              type: "success",
              duration: 3000,
            });
          })
          .catch((error) => {
            vm.submit_note_loading = false;
            vm.$notify({
              group: "status",
              title: "Success",
              text: "Something went wrong, try again",
              type: "warn",
              duration: 3000,
            });
          });
      } else {
        vm.$store
          .dispatch("NOTES_UPDATE", vm.form)
          .then((responce) => {
            vm.submit_note_loading = false;
            vm.getAllNotes();
            vm.$notify({
              group: "status",
              title: "Message",
              text: "Note is now updated",
              type: "success",
              duration: 3000,
            });
          })
          .catch((error) => {
            vm.submit_note_loading = false;
            vm.$notify({
              group: "status",
              title: "Message",
              text: "Something went wrong, try again",
              type: "warn",
              duration: 3000,
            });
          });
      }
    },
    addNewNote() {
      let vm = this;
      vm.form = {
        id: null,
        account_id: vm.$route.params.id,
        content: "",
        color: "light_yellow",
        owner: null,
      };
      vm.show_add_notes = true;
    },
    cancelAddNotes() {
      let vm = this;
      vm.show_add_notes = false;
    },
    selectNoteColor(color) {
      let vm = this;
      vm.form.color = color;
    },
    filterNotes(filter) {
      let vm = this;
      vm.sort_input_filter = false;
      vm.selected_filter = filter;
      vm.form_filter.filter = filter;
      vm.getAllNotes();
    },
    searchNote(query) {
      let vm = this;
      vm.form_filter.query = query;
      vm.getAllNotes();
    },
    getAllNotes() {
      let vm = this;
      vm.isLoading = true;
      vm.form_filter.account_id = vm.$route.params.id;
      vm.$store
        .dispatch("NOTES_GET_ALL", vm.form_filter)
        .then((responce) => {
          vm.isLoading = false;
          vm.notes_data = responce.data.map((item) => {
            if (item.created_by) {
              eventBus.$set(item, "owner", item.created_by);
            } else {
              eventBus.$set(item, "owner", null);
            }
            eventBus.$set(item, "checked", false);
            return item;
          });
          if (vm.notes_data.length > 0) {
            if (!vm.form.id) {
              let item = vm.notes_data[0];
              vm.form.id = item.id;
              vm.form.account_id = vm.$route.params.id;
              vm.form.content = item.content;
              vm.form.color = item.color;
              vm.show_add_notes = true;
            }
          }
          vm.loadSingleNote(vm.notes_data);
        })
        .catch((error) => {
          vm.isLoading = false;
        });
    },
    loadSingleNote(notes_data) {
      let vm = this;
      if (vm.$route.params.note_id) {
        let data = notes_data.find(
          (item) => item.id == vm.$route.params.note_id
        );
        vm.form.id = data.id;
        vm.form.account_id = vm.$route.params.id;
        vm.form.content = data.content;
        vm.form.color = data.color;
        vm.show_add_notes = true;
      }
    },
    filterNote(query) {
      let vm = this;
      vm.isLoading = true;
      vm.$store
        .dispatch("NOTES_FILTER", {
          filter_by: query,
        })
        .then((responce) => {
          vm.isLoading = false;
          vm.notes_data = responce.data.map((item) => {
            eventBus.$set(item, "checked", false);
            return item;
          });
        })
        .catch((error) => {
          vm.isLoading = false;
        });
    },
    deleteNote(item) {
      let vm = this;
      vm.$store
        .dispatch("NOTES_DELETE", {
          id: item.id,
        })
        .then((responce) => {
          vm.addNewNote();
          vm.getAllNotes();
          vm.$notify({
            group: "status",
            title: "Success",
            text: "Note is now deleted",
            type: "success",
            duration: 3000,
          });
        })
        .catch((error) => {
          vm.$notify({
            group: "status",
            title: "Success",
            text: "Something went wrong, try again",
            type: "warn",
            duration: 3000,
          });
        });
    },
    deletedSelectedNote() {
      let vm = this;
      vm.$store
        .dispatch("NOTES_DELETE_SELECTED", {
          ids: vm.validateCheckedNote("data"),
        })
        .then((responce) => {
          vm.getAllNotes();
          vm.$notify({
            group: "status",
            title: "Success",
            text: "Note is now deleted",
            type: "success",
            duration: 3000,
          });
        })
        .catch((error) => {
          vm.$notify({
            group: "status",
            title: "Success",
            text: "Something went wrong, try again",
            type: "warn",
            duration: 3000,
          });
        });
    },
    validateCheckedNote(type = "validate") {
      let vm = this;
      if (type == "validate") {
        vm.show_selected_activities_options =
          vm.notes_data
            .map((item) => item.checked)
            .filter((item) => item == true).length > 0;
        return;
      }
      return vm.notes_data
        .filter((item) => item.checked == true)
        .map((item) => item.id);
    },
    checkAllNote({ target }) {
      let vm = this;
      if (target.checked) {
        vm.notes_data = vm.notes_data.map((item) => {
          eventBus.$set(item, "checked", true);
          return item;
        });
      } else {
        vm.notes_data = vm.notes_data.map((item) => {
          eventBus.$set(item, "checked", false);
          return item;
        });
      }
      vm.validateCheckedNote();
    },
    checkNote(item) {
      let vm = this;
      item.checked = !item.checked;
      vm.validateCheckedNote("validate");
    },
  },
};
</script>
<style lang="scss" scoped>
$assets: "~@/assets";

.page-wrapper {
  display: flex;
  flex-direction: column;
  height: 100%;
  background: #ebebeb;
  padding: 5px;

  .page-header {
    height: 38px;
    width: 100%;
    display: flex;
    align-items: center;

    .options {
      display: flex;
      align-items: center;

      .search-account {
        width: 250px;
      }

      .btn-add {
        margin-left: 20px;
        width: 130px;
      }
    }
  }

  .page-tab {
    display: flex;
    justify-content: space-between;
    align-items: center;
    height: 35px;

    .page-path-widget {
      display: flex;
      align-items: center;

      .icon {
        width: 15px;
        margin-top: -3px;
        margin-right: 10px;
        cursor: pointer;
      }

      .allow {
        margin: 0px 10px;
      }

      .path-name {
        color: #1ba5a4;
        font-size: 12px;

        &.link {
          cursor: pointer;
        }
      }
    }
  }

  .page-body {
    height: calc(100% - 73px);
    display: flex;

    .instruct-wrapper {
      width: calc(100% - 135px);
      height: 100%;
      display: flex;
      flex-direction: column;

      .instruct-widget {
        height: 100%;
        position: relative;

        .custom-resizer {
          height: 100%;
        }

        .instruct-list {
          display: flex;
          flex-direction: column;
          height: 100%;
          min-width: calc(100% - 450px);
          width: 100%;
          border-radius: 5px;
          padding: 5px;
          background: #fff;
          position: relative;

          .instruct-body {
            height: 100%;
            overflow-y: auto;
            padding-bottom: 60px;

            .table-data {
              .activity-content {
                display: flex;
                align-items: center;

                img {
                  margin-right: 10px;
                }
              }

              .profile-widget {
                display: flex;
                align-items: center;

                img {
                  height: 25px;
                  width: 25px;
                  border-radius: 50%;
                  margin-right: 5px;
                }
              }
            }

            .notes-body-widget {
              display: grid;
              grid-template-columns: 32% 32% 32%;
              grid-gap: 12px;

              &.note_preview_showing {
                grid-template-columns: 24% 24% 24% 24%;
              }

              .note-item {
                padding: 15px;
                position: relative;
                border-radius: 5px;
                cursor: pointer;

                &.light_yellow {
                  background: #fff8a7;
                }

                &.light_red {
                  background: #f9ced7;
                }

                &.light_green {
                  background: #ebf6f2;
                }

                &.light_grey {
                  background: #ebf6f2;
                }

                .note-content {
                  margin: 0px;
                  margin-bottom: 20px;
                  display: -webkit-box;
                  -webkit-box-orient: vertical;
                  overflow: hidden;
                  text-overflow: ellipsis;
                  white-space: normal;
                  -webkit-line-clamp: 8;
                  font-size: 14px;
                }

                .page-flip {
                  position: absolute;
                  bottom: 0px;
                  left: 0px;
                  width: 20px;
                }
              }
            }
          }
        }

        .instruct-details {
          width: 400px;
          min-width: 400px;
          max-width: 450px;
          display: flex;
          flex-direction: column;
          height: 100%;
          background: #fff;
          border-radius: 5px;

          .note-form-widget {
            height: 100%;
            min-width: calc(100% - 700px);
            background: #fff;
            width: 100%;
            border-radius: 5px;
            display: flex;
            flex-direction: column;
            justify-content: space-between;
            padding-bottom: 31px;

            @media (min-width: 300px) and (max-width: 630px) {
              display: none;
            }

            .note-form {
              height: calc(100% - 65px);
              overflow-y: auto;
              padding: 5px;

              .note-colors-widget {
                display: flex;
                margin-left: 15px;

                .color-item {
                  height: 25px;
                  width: 25px;
                  margin-right: 10px;
                  border-radius: 50%;
                  cursor: pointer;
                  transition: 700ms ease-in-out;

                  &:hover {
                    border: 1px solid rgb(119, 119, 119);
                    transition: 700ms ease-in-out;
                  }

                  &.active {
                    transition: 700ms ease-in-out;
                    border: 3px solid #000;
                  }

                  &.light_yellow {
                    background: #fff8a7;
                  }

                  &.light_red {
                    background: #f9ced7;
                  }

                  &.light_green {
                    background: #ebf6f2;
                  }

                  &.light_grey {
                    background: #ebf6f2;
                  }
                }
              }
            }

            .note-options {
              height: 65px;
              display: flex;
              align-items: center;
              padding: 0px 10px;

              .btn-save {
                width: 180px;
                height: 45px;
                background: #0884af;
                border-radius: 5px;
                color: #fff;
                margin-right: 40px;
              }

              .btn-cancel {
                height: 45px;
              }
            }
          }

          .empty-widget {
            display: flex;
            align-content: center;
            justify-content: center;

            h1 {
              font-size: 20px;
              color: #ddd;
              margin-top: 200px;
            }
          }
        }
      }

      .student-not-found-widget {
        width: 100%;
        height: 100%;
        display: flex;
        flex-direction: column;
        background: #fff;
        border-radius: 5px;
      }

      .form-widget-modal {
        width: 500px;
        min-height: 200px;
        padding: 20px;

        .moder-header {}

        .modal-body {
          .input-group {
            position: relative;

            .exist-company {
              width: 100%;

              .input-form {
                width: 100%;
              }

              .selected-company {
                border: 1px solid #ddd;
                background: #fff;
                height: 50px;
                display: flex;
                align-items: center;
                justify-content: space-between;
                padding: 0px 10px;

                .content {
                  display: flex;
                  align-items: center;

                  img {
                    width: 30px;
                    height: 30px;
                    margin-right: 10px;
                  }
                }

                .option {
                  .btn-close {
                    font-size: 20px;
                    background: #7f0404;
                    color: #fff;
                    border-radius: 5px;
                  }
                }
              }

              .search-result-widget {
                position: absolute;
                top: 75px;
                height: 200px;
                width: 100%;
                background: #fff;
                z-index: 999;
                box-shadow: 0px 0px 3px #ccc;
                border-radius: 5px;
                overflow-y: auto;

                .search-item {
                  display: flex;
                  align-items: center;
                  padding: 4px 10px;
                  border-bottom: 1px solid #ddd;
                  cursor: pointer;

                  &:hover {
                    background: rgb(240, 240, 240);
                  }

                  img {
                    width: 40px;
                    height: 40px;
                    object-fit: cover;
                    border-radius: 50%;
                    margin-right: 15px;
                  }
                }
              }
            }

            .new-company-field {
              width: 100%;

              .input-form {
                width: 100%;
              }
            }
          }
        }
      }
    }
  }
}

.search-contact-item {
  padding: 10px 15px;
  display: flex;
  cursor: pointer;
  align-items: center;

  img {
    border-radius: 50%;
    margin-right: 8px;
  }

  &:hover {
    background: rgb(250, 250, 250);
  }
}

.selected-search-contact-item {
  padding: 5px 12px;
  display: flex;
  align-items: center;
  cursor: pointer;
  border: 1px solid #ddd;
  margin-top: 10px;
  border-radius: 15px;
  font-size: 11px;

  img {
    border-radius: 50%;
    margin-right: 8px;
  }

  &:hover {
    background: rgb(250, 250, 250);
  }
}
</style>

<style lang="scss">
.notes-editor-widget {
  .ql-container.ql-snow {
    border: 1px solid #fff;
    height: 400px;
  }
}
</style>
